export default __webpack_public_path__ + "static/media/import-points-example-en.89e9309f.xlsx";